module.exports = __webpack_public_path__ + "static/media/Turkish_Mine BG-03.f176b19f.png";